exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-6ca010ab]{min-height:500px;background:#fff}.modal-label[data-v-6ca010ab]{font-family:artifaktElementBold}.modal-sub-title[data-v-6ca010ab]{font-size:20px}.invoice-modal-body[data-v-6ca010ab]{background-color:#e7f4ff;padding:0 30px 30px 20px}", ""]);

// exports
